import React from 'react';
import BaseComponent from './BaseComponent';

class SearchAutocomplete extends BaseComponent {

    constructor(props){
	super(props);
    	this.changeQuery = this.changeQuery.bind(this);
    	this.onFocus = this.onFocus.bind(this);
    	this.onBlur = this.onBlur.bind(this);
    	this.selectOption = this.selectOption.bind(this);
    	this.cleanSelection = this.cleanSelection.bind(this);
    	this.fieldToLookFor = this.props.lookFor?this.props.lookFor:'name';

	this.stateLoaded = false;
	this.state = {elements: [], selected: null};

	if(!this.props.onOptionSelected) throw new Error("You must define onOptionSelected property for SearchAutocomplete component.");
	this.optionsList = React.createRef();
	this.searchInput = React.createRef();

		
    }

    changeQuery(event){
    	this.stateLoaded = true;
    	const query = event.target?event.target.value:event.value;
	
	let newElements = this.props.data.filter(el => {
		const normalizedQuery = this.normalizeString(query.toLowerCase());
		const normalizedElement = this.normalizeString(String(el[this.fieldToLookFor]).toLowerCase());

		return el[this.fieldToLookFor] && normalizedElement.indexOf(normalizedQuery) > -1;
	})
	newElements = newElements.splice(0,this.props.maxElementsToDisplay || 20);

	this.setState(prevState => {
		return {
			...prevState,
		    	elements: newElements
		}
	});
    }

    normalizeString(str){
	return str.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
    }

    onMouseEnter(e){
	e.target.style.background ='#CCC';
    }

    onMouseLeave(e){
	e.target.style.background ='';
    }

    selectOption(elem){
	this.searchInput.current.value = elem[this.fieldToLookFor];
	this.setState(prevState => {
		return {
			...prevState,
		    	selected: this.state.selected !== null?this.state.selected:this.props.selected
		}
	});
	//this.selected = this.selected === null?this.selected.this.props.selected:this.selected;
	this.changeQuery(this.searchInput.current);
	this.props.onOptionSelected(elem);
    }

    onFocus(e){
	this.optionsList.current.style.display = 'block';
    }

    onBlur(e){
    	//Se pone un setTimeOut para que primero se haga el click y luego se oculte, de lo contrario no se ejecuta el click
    	setTimeout(() => { this.optionsList.current.style.display = 'none'; }, 200);
    }

    cleanSelection(){
	this.searchInput.current.value = "";
	this.changeQuery(this.searchInput.current);
	this.props.onOptionSelected(null);
    }

    render(){
    	const selected = this.state.selected!== null?this.state.selected[this.props.displayField]:
		this.props.selected?this.props.selected[this.props.displayField]:''

    	return (
    		<>
			<input ref={this.searchInput} type="text" onFocus={this.onFocus} className={this.props.className?this.props.className:undefined}
			onBlur={this.onBlur} onChange={this.changeQuery} defaultValue={selected} />
			<span style={this.dropButton} onClick={this.cleanSelection} >X</span>
			<ul ref={this.optionsList} style={this.floatingSquare}>
			{this.props.data.map((elem,id) => {
				const opt = <li key={'autocomplete_'+elem[this.fieldToLookFor]+id}
					   	style={{textOverflow: 'ellipsis'}}
					   	onClick={this.selectOption.bind(this, elem)}
					   	onMouseEnter={this.onMouseEnter} 
					   	onMouseLeave={this.onMouseLeave} >
					   	{elem[this.props.displayField] || elem.name}
					    </li> ;

				return !this.stateLoaded?opt:this.state.elements.indexOf(elem) > -1?opt:false;
				})}
			</ul>
    		</>
        )
    }

    floatingSquare = {
	width: 'auto',
	marginTop: '-3px',
	minWidth: '203px',
	minHeight: '30px',
	maxHeight: '300px',
	maxWidth: '250px',
	height: 'auto',
	border: '1px solid #CCC',
	position: 'absolute',
	zIndex: '1',
	background: '#FFF',
	marginLeft: '3px',
	padding: '3px 5px',
	listStyleType: 'none',
	display: 'none',
	overflowY: 'auto',
	overflowX: 'hidden',
	textOverflow: 'ellipsis'
    }

    dropButton = {
	width: '25px',
	height: '30px',
	paddingTop: '3px',
	paddingLeft: '7px',
	cursor: 'pointer',
	background: '#007bff',
	color: 'white',
	marginLeft: '-1px',
	display: 'inline-block',

    }
}

export default SearchAutocomplete;
